export default {
  "menu.welcome": "Welcome",
  "menu.more-blocks": "More Blocks",
  "menu.home": "Home",
  "menu.admin": "Admin",
  "menu.admin.sub-page": "Sub-Page",
  "menu.login": "Login",
  "menu.register": "Register",
  "menu.register-result": "Register Result",

  "menu.users": "User Management",
  "menu.users.user-list": "User List",
  "menu.users.user-detail": "User Detail",
  "menu.users.create-user": "Create User",
  "menu.food-database": "Food Database",
  "menu.food-database.foods": "Foods",
  "menu.food-database.foods.food-list": "Food List",
  "menu.food-database.foods.create-food": "Create Food",
  "menu.food-database.foods.update-food": "Update Food",
  "menu.food-database.foods.food-detail": "Food Detail",
  "menu.food-database.categories": "Categories",
  "menu.food-database.categories.category-list": "Category List",
  "menu.food-database.categories.create-category": "Create Category",
  "menu.food-database.categories.update-category": "Update Category",
  "menu.food-database.categories.category-detail": "Category Detail",
  "menu.food-database.brands": "Brands",
  "menu.food-database.brands.brand-list": "Brand List",
  "menu.food-database.brands.create-brand": "Create Brand",
  "menu.food-database.brands.update-brand": "Update Brand",
  "menu.food-database.brands.brand-detail": "Brand Detail",
  "menu.submissions": "Food Submissions",
  "menu.submissions.pending-submissions": "Pending Food Submissions",
  "menu.submissions.all-submissions": "All Food Submissions",
  "menu.submissions.submission-detail": "Food Submission Detail",
  "menu.submissions.review-submission": "Review Food Submission",
  "menu.submissions.submission-history": "Food Submission History",
  "menu.tools": "Tools",
  "menu.tools.check-barcode": "Check Barcode",
  "menu.account.center": "Account Center",
  "menu.account.settings": "Settings",
  "menu.account.logout": "Logout",
  "menu.editor": "Graphic Editor",
  "menu.editor.flow": "Flow Editor",
  "menu.editor.mind": "Mind Editor",
  "menu.editor.koni": "Koni Editor",
};
